<template>
  <div class="o-settings">
    <app-navigation :currentSpace="$t('web.settings.nav_space')" :hideAuxNavOnDesktop="true"></app-navigation>




    <main class="o-settings__main">
      <section class="c-page-header">
        <div class="c-page-header__left">
          <h1 class="c-page-header__left__title">{{ full_name }}</h1>
        </div>

        <div class="c-page-header__right">
          <a
            @click="logout"
            href="javascript:;"
            class="c-button t-button-primary qa-logout"
          >
            {{ $t('web.settings.logout') }}
          </a>
        </div>
      </section>




      <section class="c-card c-card--setting">
        <div class="c-card__header">
          <h2 class="c-card__title t-headline">{{ $t('web.settings.card_account_info_header') }}</h2>
        </div>


        <section class="c-card--setting__section">
          <h3 class="u-label">{{ $t('web.settings.primary_email_label') }}</h3>


          <!--VIEW-->
          <div
            v-if  = "layout.section1.template=='detail'"
            class = "c-card--setting__view-fields"
          >
            <p class="c-card--setting__content u-word-wrap">{{ participant.primary_email }}</p>
            <p class="c-card--setting__fieldset__note">{{ $t('web.settings.primary_email_hint') }}</p>
            <div class="c-card--setting__buttons c-card--setting__buttons--default-mode">
              <button
                @click = "edit('section1')"
                class  = "c-button t-button-plain qa-edit-username"
              >
                {{ $t('web.settings.edit_button') }}
              </button>
            </div>
          </div>


          <!--EDIT-->
          <div
            v-if  = "layout.section1.template=='edit'"
            class = "c-card--setting__edit-fields"
          >
            <label class="u-hidden-label" for="username">
              {{ $t('web.settings.primary_email_label') }}{{ metadata.primary_email.required ? '*' : '' }}
            </label>
            <input
              v-model  = "participant.primary_email"
              type     = "email"
              name     = "username"
              tabindex = "1"
              class    = "qa-settings-username-input"
            >
            <p class="c-card--setting__fieldset__note">
              {{ $t('web.settings.primary_email_hint') }}
            </p>
            <div v-for="error in errors.primary_email">
              <div class="c-validation t-alert-danger qa-validation qa-validation">
                {{ error }}
              </div>
            </div>

            <div class="c-card--setting__buttons c-card--setting__buttons--edit-mode">
              <button
                @click   = "reset()"
                class    = "c-button t-button-plain qa-cancel-username"
                tabindex = "3"
              >
                {{ $t('web.settings.cancel_button') }}
              </button>
              <button
                @click   = "save('section1')"
                class    = "c-button t-button-primary qa-save"
                tabindex = "2"
              >
                {{ $t('web.settings.save_button') }}
              </button>
            </div>
          </div>
        </section>


        <section class="c-card--setting__section">
          <h3 class="u-label">{{ $t('web.settings.password_label') }}</h3>


          <!--VIEW-->
          <div
            v-if  = "layout.password_section.template=='detail'"
            class = "c-card--setting__view-fields"
          >
            <p class="c-card--setting__content">************</p>
            <div class="c-card--setting__buttons c-card--setting__buttons--default-mode">
              <button
                @click = "edit('password_section')"
                class  = "c-button t-button-plain qa-edit-password"
              >
                {{ $t('web.settings.edit_button') }}
              </button>
            </div>
          </div>


          <!--EDIT-->
          <div
            v-if  = "layout.password_section.template=='edit'"
            class = "c-card--setting__edit-fields"
          >
            <ul class="u-tiny-list">
              <li>{{ $t('web.settings.new_password_minimum_12_characters_note') }}</li>
              <li>{{ $t('web.settings.new_password_minimum_1_number_note') }}</li>
              <li>{{ $t('web.reset_password.new_password_minimum_1_symbol') }}</li>
              <li>{{ $t('web.settings.new_password_minimum_1_uppercase_note') }}</li>
            </ul>

            <fieldset class="c-card--setting__fieldset">
              <label for="old_password" class="u-sub-label">{{ $t('web.settings.old_password_label') }}*</label>
              <input
                v-model  = "participant.old_password"
                type     = "password"
                name     = "old_password"
                tabindex = "1"
                class    = "qa-settings-old-password-input"
              />
              <div v-for="error in errors.old_password">
                <div class="c-validation t-alert-danger qa-validation">
                  {{ error }}
                </div>
              </div>
            </fieldset>

            <fieldset class="c-card--setting__fieldset" >
              <label for="new_password" class="u-sub-label">{{ $t('web.settings.new_password_label') }}*</label>
              <input
                v-model  = "participant.new_password"
                type     = "password"
                name     = "new_password"
                tabindex = "2"
                class    = "qa-settings-new-password-input"
              >
              <div v-for="error in errors.new_password">
                <div class="c-validation t-alert-danger qa-validation">
                  {{ error }}
                </div>
              </div>
            </fieldset>

            <fieldset class="c-card--setting__fieldset">
              <label class="u-sub-label" for="confirm_new_password">
                {{ $t('web.settings.confirm_new_password_label') }}*
              </label>
              <input
                v-model  = "participant.confirm_new_password"
                type     = "password"
                name     = "confirm_new_password"
                tabindex = "3"
                class    = "qa-settings-confirm-password-input"
              >
              <div v-for="error in errors.confirm_new_password">
                <div class="c-validation t-alert-danger qa-validation">
                  {{ error }}
                </div>
              </div>
            </fieldset>

            <div class="c-card--setting__buttons c-card--setting__buttons--edit-mode">
              <button
                @click   = "reset()"
                class    = "c-button t-button-plain qa-cancel-password"
                tabindex = "5"
              >
                {{ $t('web.settings.cancel_button') }}
              </button>
              <button
                @click="save('password_section')"
                class="c-button t-button-primary qa-save"
                tabindex="4"
              >
                {{ $t('web.settings.save_button') }}
              </button>
            </div>
          </div>
        </section>


        <section class="c-card--setting__section">
          <h3 class="u-label">{{ $t('web.settings.name_label') }}</h3>


          <!--VIEW-->
          <div
            v-if  = "layout.section3.template=='detail'"
            class = "c-card--setting__view-fields"
          >
            <label class="u-sub-label u-hidden-label">{{ $t('web.settings.name_label') }}</label>
            <p
              :class = "{'u-paragraph--empty-field' : (full_name===$t('web.settings.name_not_entered'))}"
              class  = "u-paragraph"
            >
              {{ full_name }}
            </p>
            <div class="c-card--setting__buttons c-card--setting__buttons--default-mode">
              <button
                @click = "edit('section3')"
                class  = "c-button t-button-plain qa-edit-name"
              >
                {{ $t('web.settings.edit_button') }}
              </button>
            </div>
          </div>


          <!--EDIT-->
          <div
            v-if  = "layout.section3.template=='edit'"
            class = "c-card--setting__edit-fields"
          >
            <fieldset class="c-card--setting__fieldset">
              <label class="u-sub-label" for="first_name">
                {{ $t('web.settings.first_name_label') }}{{ metadata.first_name.required ? '*' : '' }}
              </label>
              <input
                v-model  = "participant.first_name"
                type     = "text"
                name     = "first_name"
                tabindex = "1"
                class    = "qa-settings-first-name-input"
              />
              <div v-for="error in errors.first_name">
                <div class="c-validation t-alert-danger qa-validation">
                  {{ error }}
                </div>
              </div>
            </fieldset>

            <fieldset class="c-card--setting__fieldset">
              <label class="u-sub-label" for="last_name">
                {{ $t('web.settings.last_name_label') }}{{ metadata.last_name.required ? '*' : '' }}
              </label>
              <input
                v-model  = "participant.last_name"
                type     = "text"
                name     = "last_name"
                tabindex = "2"
                class    = "qa-settings-last-name-input"
              />
              <div v-for="error in errors.last_name">
                <div class="c-validation t-alert-danger qa-validation">
                  {{ error }}
                </div>
              </div>
            </fieldset>

            <div class="c-card--setting__buttons c-card--setting__buttons--edit-mode">
              <button
                @click   = "reset()"
                class    = "c-button t-button-plain"
                tabindex = "4"
              >
                {{ $t('web.settings.cancel_button') }}
              </button>
              <button
                @click   = "save('section3')"
                class    = "c-button t-button-primary qa-save"
                tabindex = "3"
              >
                {{ $t('web.settings.save_button') }}
              </button>
            </div>
          </div>
        </section>


        <section class="c-card--setting__section">
          <h3 class="u-label">{{ $t('web.settings.preferred_name_label') }}</h3>


          <!--VIEW-->
          <div
            v-if  = "layout.section4.template=='detail'"
            class = "c-card--setting__view-fields"
          >
            <p
              :class = "{'u-paragraph--empty-field' : (preferred_full_name===$t('web.settings.preferred_name_not_entered'))}"
              class  = "u-paragraph"
            >
              {{ preferred_full_name }}
            </p>
            <div class="c-card--setting__buttons c-card--setting__buttons--default-mode">
              <button
                @click = "edit('section4')"
                class  = "c-button t-button-plain qa-edit-preferredname"
              >
                {{ $t('web.settings.edit_button') }}
              </button>
            </div>
          </div>


          <!--EDIT-->
          <div
            v-if  = "layout.section4.template=='edit'"
            class = "c-card--setting__edit-fields"
          >
            <fieldset class="c-card--setting__fieldset">
              <label
                class = "u-sub-label"
                for   = "preferred_first_name"
              >
                {{ $t('web.settings.preferred_first_name_label') }}{{ metadata.preferred_first_name.required ? '*' : '' }}
              </label>
              <input
                v-model  = "participant.preferred_first_name"
                type     = "text"
                name     = "preferred_first_name"
                tabindex = "1"
                class    = "qa-settings-preferred-first-name-input"
              />
              <div v-for="error in errors.preferred_first_name">
                <div class="c-validation t-alert-danger qa-validation">
                  {{ error }}
                </div>
              </div>
            </fieldset>

            <fieldset class="c-card--setting__fieldset">
              <label class="u-sub-label" for="preferred_last_name">
                {{ $t('web.settings.preferred_last_name_label') }}{{ metadata.preferred_last_name.required ? '*' : '' }}
              </label>
              <input
                v-model  = "participant.preferred_last_name"
                type     = "text"
                name     = "preferred_last_name"
                tabindex = "2"
                class    = "qa-settings-preferred-last-name-input"
              />
              <div v-for="error in errors.preferred_last_name">
                <div class="c-validation t-alert-danger qa-validation">
                  {{ error }}
                </div>
              </div>
            </fieldset>

            <div class="c-card--setting__buttons c-card--setting__buttons--edit-mode">
              <button
                @click   = "reset()"
                class    = "c-button t-button-plain"
                tabindex = "4"
              >
                {{ $t('web.settings.cancel_button') }}
              </button>
              <button
                @click   = "save('section4')"
                class    = "c-button t-button-primary qa-save"
                tabindex = "3"
              >
                {{ $t('web.settings.save_button') }}
              </button>
            </div>
          </div>
        </section>
      </section>

      <section
        v-if  = "customProfile.fields.length > 0"
        class = "c-card c-card--setting"
      >
        <div class="c-card__header">
          <h2 class="c-card__title t-headline">{{ customProfile.name }}</h2>
        </div>


        <section
          v-for = "field in customProfile.fields"
          class = "c-card--setting__section"
        >
          <h3
            v-if  = "layout['custom_section_' + field.name]"
            class = "c-card--setting__view-label u-label"
          >
            {{ field.label }}
          </h3>


          <!--VIEW-->
          <div
            v-if  = "layout['custom_section_' + field.name] &&
                     layout['custom_section_' + field.name].template=='detail'"
            :name = "field.name"
            class = "c-card--setting__view-fields"
          >
            <component
              v-model    = "participant[field.name]"
              labelClass = "u-hidden-label"
              :is        = "getFieldComponentType(field)"
              :field     = "field"
              :errors    = "errors"
              :name      = "field.name"
              :template  = "layout['custom_section_' + field.name].template">
            </component>
            <div
              v-if  = "!field.readonly"
              class = "c-card--setting__buttons c-card--setting__buttons--default-mode"
            >
              <button
                @click = "edit('custom_section_' + field.name)"
                class  = "c-button t-button-plain"
                :class   = "'qa-' + field.name + '__edit'"
              >
                {{ $t('web.settings.edit_button') }}
              </button>
            </div>
          </div>


          <!--EDIT-->
          <div
            v-if  = "layout['custom_section_' + field.name]
                     && layout['custom_section_' + field.name].template=='edit'
                     && !field.readonly"
            class = "c-card--setting__edit-fields"
          >
            <fieldset class="o-fieldset c-card--submit-claim__fieldset">
              <component
                v-model    = "participant[field.name]"
                labelClass = "u-hidden-label"
                :is        = "getFieldComponentType(field)"
                :field     = "field"
                :errors    = "errors"
                :name      = "field.name"
                :template  = "layout['custom_section_' + field.name].template">
              </component>
              <div v-for="error in errors[field.name]">
                <div class="c-validation t-alert-danger qa-validation">{{ error }}</div>
              </div>
            </fieldset>

            <div class="c-card--setting__buttons c-card--setting__buttons--edit-mode">
              <button
                @click   = "reset()"
                class    = "c-button t-button-plain"
                :class   = "'qa-cancel'"
                tabindex = "3"
              >
                {{ $t('web.settings.cancel_button') }}
              </button>
              <button
                @click   = "save('custom_section_' + field.name)"
                class    = "c-button t-button-primary qa-save"
                :class   = "'qa-save'"
                tabindex = "2"
              >
                {{ $t('web.settings.save_button') }}
              </button>
            </div>
          </div>
        </section>
      </section>




      <section class="c-card c-card--setting">
        <div class="c-card__header">
          <h2 class="c-card__title t-headline">{{ $t('web.settings.card_contact_info_header') }}</h2>
        </div>


        <section class="c-card--setting__section">
          <h3 class="u-label">{{ $t('web.settings.email_addresses_label') }}</h3>


          <!--VIEW-->
          <div
            v-if  = "layout.section6.template=='detail'"
            class = "c-card--setting__view-fields"
          >

            <div class="c-card--setting__fieldset">
              <label class="u-sub-label">{{ $t('web.settings.secondary_email_label') }}</label>
              <p
                :class = "{'u-paragraph--empty-field' : (!participant.secondary_email)}"
                class  = "u-paragraph u-word-wrap"
              >
                {{ participant.secondary_email ? participant.secondary_email : $t('web.settings.secondary_email_not_entered') }}
              </p>
            </div>

            <div class="c-card--setting__fieldset">
              <label class="u-sub-label">{{ $t('web.settings.other_email_label') }}</label>
              <p
                :class = "{'u-paragraph--empty-field' : (!participant.other_email)}"
                class  = "u-paragraph u-word-wrap"
              >
                {{ participant.other_email ? participant.other_email : $t('web.settings.other_email_not_entered') }}
              </p>
            </div>

            <div class="c-card--setting__buttons c-card--setting__buttons--default-mode">
              <button
                @click = "edit('section6')"
                class  = "c-button t-button-plain qa-edit-email-addresses"
              >
                {{ $t('web.settings.edit_button') }}
              </button>
            </div>
          </div>


          <!--EDIT-->
          <div
            v-if  = "layout.section6.template=='edit'"
            class = "c-card--setting__edit-fields"
          >
            <fieldset class="c-card--setting__section-fieldset">
              <label class="u-sub-label" for="secondary_email">
                {{ $t('web.settings.secondary_email_label') }}{{ metadata.secondary_email.required ? '*' : '' }}
              </label>
              <input
                v-model  = "participant.secondary_email"
                type     = "email"
                name     = "secondary_email"
                tabindex = "1"
                class    = "qa-settings-secondary-email-input"
              />
              <div v-for="error in errors.secondary_email">
                <div class="c-validation t-alert-danger qa-validation">
                  {{ error }}
                </div>
              </div>
            </fieldset>

            <fieldset class="c-card--setting__section-fieldset">
              <label class="u-sub-label" for="other_email">
                {{ $t('web.settings.other_email_label') }}{{ metadata.other_email.required ? '*' : '' }}
              </label>
              <input
                v-model  = "participant.other_email"
                type     = "email"
                name     = "other_email"
                tabindex = "2"
                class    = "qa-settings-other-email-input"
              >
              <div v-for="error in errors.other_email">
                <div class="c-validation t-alert-danger qa-validation">{{ error }}</div>
              </div>
            </fieldset>

            <div class="c-card--setting__buttons c-card--setting__buttons--edit-mode">
              <button @click="reset()" class="c-button t-button-plain" tabindex="4">
                {{ $t('web.settings.cancel_button') }}
              </button>
              <button
                @click   = "save('section6')"
                class    = "c-button t-button-primary qa-save"
                tabindex = "3"
              >
                {{ $t('web.settings.save_button') }}
              </button>
            </div>
          </div>
        </section>


        <section class="c-card--setting__section c-card--setting__section--phones">
          <h3 class="u-label">{{ $t('web.settings.phone_numbers_label') }}</h3>


          <!--VIEW-->
          <div v-if="layout.section7.template=='detail'" class="c-card--setting__view-fields">
            <div class="c-card--setting__fieldset c-card--setting__section--phones__fieldset">
              <label class="u-sub-label">{{ $t('web.settings.mobile_phone_label') }}</label>
              <p
                :class = "{'u-paragraph--empty-field' : (!participant.mobile_phone)}"
                class  = "u-paragraph"
              >
                {{ participant.mobile_phone ? participant.mobile_phone : $t('web.settings.mobile_phone_not_entered') }}
              </p>
            </div>

            <div class="c-card--setting__fieldset c-card--setting__section--phones__fieldset">
              <label class="u-sub-label">{{ $t('web.settings.business_phone_label') }}</label>
              <p
                :class = "{'u-paragraph--empty-field' : (!participant.business_phone)}"
                class  = "u-paragraph"
              >
                {{ participant.business_phone ? participant.business_phone : $t('web.settings.business_phone_not_entered') }}
              </p>
            </div>

            <div class="c-card--setting__fieldset c-card--setting__section--phones__fieldset">
              <label class="u-sub-label">{{ $t('web.settings.home_phone_label') }}</label>
              <p
                :class = "{'u-paragraph--empty-field' : (!participant.home_phone)}"
                class  = "u-paragraph"
              >
                {{ participant.home_phone ? participant.home_phone : $t('web.settings.home_phone_not_entered') }}
              </p>
            </div>

            <div class="c-card--setting__buttons c-card--setting__buttons--default-mode">
              <button
                @click = "edit('section7')"
                class  = "c-button t-button-plain qa-edit-phone-numbers"
              >
                {{ $t('web.settings.edit_button') }}
              </button>
            </div>
          </div>


          <!--EDIT-->
          <div v-if="layout.section7.template=='edit'" class="c-card--setting__edit-fields">
            <fieldset class="c-card--setting__fieldset c-card--setting__section--phones__fieldset">
              <label class="u-sub-label" for="mobile_phone">
                {{ $t('web.settings.mobile_phone_label') }}{{ metadata.mobile_phone.required ? '*' : '' }}
              </label>
              <input
                v-model  = "participant.mobile_phone"
                type     = "text"
                name     = "mobile_phone"
                tabindex = "1"
                class    = "qa-settings-mobile-phone-input"
              />
              <div v-for="error in errors.mobile_phone">
                <div class="c-validation t-alert-danger qa-validation">{{ error }}</div>
              </div>
            </fieldset>

            <fieldset class="c-card--setting__fieldset c-card--setting__section--phones__fieldset">
              <label class="u-sub-label" for="business_phone">
                {{ $t('web.settings.business_phone_label') }}{{ metadata.business_phone.required ? '*' : '' }}
              </label>
              <input
                v-model  = "participant.business_phone"
                type     = "text"
                name     = "business_phone"
                tabindex = "2"
                class    = "qa-settings-business-phone-input"
              />
              <div v-for="error in errors.business_phone">
                <div class="c-validation t-alert-danger qa-validation">
                  {{ error }}
                </div>
              </div>
            </fieldset>

            <fieldset class="c-card--setting__fieldset c-card--setting__section--phones__fieldset">
              <label for="home_phone" class="u-sub-label">
                {{ $t('web.settings.home_phone_label') }}{{ metadata.home_phone.required ? '*' : '' }}
              </label>
              <input
                v-model  = "participant.home_phone"
                type     = "text"
                name     = "home_phone"
                tabindex = "3"
                class    = "qa-settings-home-phone-input"
              />
              <div v-for="error in errors.home_phone">
                <div class="c-validation t-alert-danger qa-validation">
                  {{ error }}
                </div>
              </div>
            </fieldset>

            <div class="c-card--setting__buttons c-card--setting__buttons--edit-mode">
              <button
                @click   = "reset()"
                class    = "c-button t-button-plain"
                tabindex = "5"
              >
                {{ $t('web.settings.cancel_button') }}
              </button>
              <button
                @click   = "save('section7')"
                class    = "c-button t-button-primary qa-save"
                tabindex = "4"
              >
                {{ $t('web.settings.save_button') }}
              </button>
            </div>
          </div>
        </section>


        <section class="c-card--setting__section">
          <h3 class="u-label">{{ $t('web.settings.home_address_label') }}</h3>


          <!--VIEW-->
          <div v-if="layout.section8.template=='detail'" class="c-card--setting__view-fields">
            <div class="c-card--setting__fieldset">
              <address v-if="home_address_empty" class="u-paragraph u-paragraph--empty-field">
                {{ $t('web.settings.home_address_not_entered') }}
              </address>
              <address v-if="!home_address_empty" class="u-paragraph">
                {{ participant.home_address1 }} <br v-if="participant.home_address1">
                {{ participant.home_address2 }} <br v-if="participant.home_address2">
                {{ participant.home_city ? (participant.home_city + ', ') : '' }}
                {{ participant.home_state ? (participant.home_state + ' ') : '' }}
                {{ participant.home_zip_code }} <br v-if="participant.home_country">
                {{ getDropdownLabel(participant.home_country, metadata.home_country.options) }}
              </address>
            </div>
            <div class="c-card--setting__buttons c-card--setting__buttons--default-mode">
              <button
                @click = "edit('section8')"
                class  = "c-button t-button-plain qa-edit-legal-address"
              >
                {{ $t('web.settings.edit_button') }}
              </button>
            </div>
          </div>


          <!--EDIT-->
          <div v-if="layout.section8.template=='edit'" class="c-card--setting__edit-fields">
            <p class="c-card--setting__fieldset__note">{{ $t('web.settings.home_address_hint') }}</p>

            <fieldset class="c-card--setting__fieldset c-card--setting__fieldset--address">
              <label for="home_address1" class="u-sub-label u-word-wrap">
                {{ $t('web.settings.home_address1_label') }}{{ metadata.home_address1.required ? '*' : '' }}
              </label>
              <input
                v-model  = "participant.home_address1"
                type     = "text"
                name     = "home_address2"
                tabindex = "1"
                class    = "qa-settings-street-line-1-input"
              />
              <div v-for="error in errors.home_address1">
                <div class="c-validation t-alert-danger qa-validation">
                  {{ error }}
                </div>
              </div>

              <label for="home_address2" class="u-sub-label">
                {{ $t('web.settings.home_address2_label') }}{{ metadata.home_address2.required ? '*' : '' }}
              </label>
              <input
                v-model      = "participant.home_address2"
                type         = "text"
                name         = "home_address2"
                :placeholder = "$t('web.settings.home_address2_placeholder')"
                tabindex     = "2"
                class        = "qa-settings-street-line-2-input"
              />
              <div v-for="error in errors.home_address2">
                <div class="c-validation t-alert-danger qa-validation">
                  {{ error }}
                </div>
              </div>

              <div class="c-card--setting__fieldset--address__city-state-zip-country">
                <label for="home_city" class="u-sub-label">
                  {{ $t('web.settings.home_city_label') }}{{ metadata.home_city.required ? '*' : '' }}
                </label>
                <input
                  v-model  = "participant.home_city"
                  type     = "text"
                  name     = "home_city"
                  tabindex = "3"
                  class    = "qa-settings-city-input"
                />
                <div v-for="error in errors.home_city">
                  <div class="c-validation t-alert-danger qa-validation">
                    {{ error }}
                  </div>
                </div>

                <label for="home_state" class="u-sub-label">
                  {{ $t('web.settings.home_state_label') }}{{ metadata.home_state.required ? '*' : '' }}
                </label>
                <select
                  v-model  = "participant.home_state"
                  name     = "home_state"
                  tabindex = "4"
                  class    = "qa-settings-state-input"
                >
                  <option value=""></option>
                  <option
                    v-for  = "item in metadata.home_state.options"
                    :value = "item.value"
                  >
                    {{ item.label }}
                  </option>
                </select>
                <div v-for="error in errors.home_state">
                  <div class="c-validation t-alert-danger qa-validation">
                    {{ error }}
                  </div>
                </div>

                <label for="legal-zip" class="u-sub-label">
                  {{ $t('web.settings.home_zip_code_label') }}{{ metadata.home_zip_code.required ? '*' : '' }}
                </label>
                <input
                  v-model   = "participant.home_zip_code"
                  type      = "text"
                  maxlength = "6"
                  name      = "home_zip_code"
                  tabindex  = "5"
                  class    = "qa-settings-zip-input"
                />
                <div v-for="error in errors.home_zip_code">
                  <div class="c-validation t-alert-danger qa-validation">
                    {{ error }}
                  </div>
                </div>

                <label for="home_country" class="u-sub-label">
                  {{ $t('web.settings.home_country_label') }}{{ metadata.home_country.required ? '*' : '' }}
                </label>
                <select
                  v-model  = "participant.home_country"
                  name     = "home_country"
                  tabindex = "6"
                  class    = "qa-settings-country-input"
                >
                  <option value=""></option>
                  <option
                    v-for  = "item in metadata.home_country.options"
                    :value = "item.value"
                  >
                    {{ item.label }}
                  </option>
                </select>
                <div v-for="error in errors.home_country">
                  <div class="c-validation t-alert-danger qa-validation">
                    {{ error }}
                  </div>
                </div>

              </div>
            </fieldset>

            <!--EDIT-->
            <div class="c-card--setting__buttons c-card--setting__buttons--edit-mode">
              <button
                @click   = "reset()"
                class    = "c-button t-button-plain"
                tabindex = "8"
              >
                {{ $t('web.settings.cancel_button') }}
              </button>
              <button
                @click   = "save('section8')"
                class    = "c-button t-button-primary qa-save"
                tabindex = "7"
              >
                {{ $t('web.settings.save_button') }}
              </button>
            </div>
          </div>
        </section>


        <section class="c-card--setting__section">
          <h3 class="u-label">{{ $t('web.settings.shipping_information_label') }}</h3>


          <!--VIEW-->
          <div
            v-if  = "layout.section9.template=='detail'"
            class = "c-card--setting__view-fields"
          >
            <div class="c-card--setting__fieldset">
              <label class="u-sub-label">{{ $t('web.settings.shipping_address_label') }}</label>
              <address v-if="shipping_address_empty" class="u-paragraph u-paragraph--empty-field">
                {{ $t('web.settings.shipping_address_not_entered') }}
              </address>
              <address v-if="!shipping_address_empty" class="u-paragraph">
                {{ participant.shipping_first_name }} <br v-if="participant.shipping_first_name">
                {{ participant.shipping_last_name }} <br v-if="participant.shipping_last_name">
                {{ participant.shipping_address1 }} <br v-if="participant.shipping_address1">
                {{ participant.shipping_address2 }} <br v-if="participant.shipping_address2">
                {{ participant.shipping_city ? (participant.shipping_city + ', ') : '' }}
                {{ participant.shipping_state ? (participant.shipping_state + ' ') : '' }}
                {{ participant.shipping_zip_code }} <br v-if="participant.shipping_country">
                {{ getDropdownLabel(participant.shipping_country, metadata.shipping_country.options) }}
              </address>

              <label class="u-sub-label">{{ $t('web.settings.shipping_email_label') }}</label>
              <span v-if="participant.shipping_email" class="u-paragraph u-word-wrap">
                {{ participant.shipping_email }}
              </span>
              <span v-else class="u-paragraph u-paragraph--empty-field">
                {{ $t('web.settings.shipping_email_not_entered') }}
              </span>

              <label class="u-sub-label">{{ $t('web.settings.shipping_phone_label') }}</label>
              <span v-if="participant.shipping_phone" class="u-paragraph">
                {{ participant.shipping_phone }}
              </span>
              <span v-else class="u-paragraph u-paragraph--empty-field">
                {{ $t('web.settings.shipping_phone_not_entered') }}
              </span>
            </div>

            <div class="c-card--setting__buttons c-card--setting__buttons--default-mode">
              <button
                @click = "edit('section9')"
                class  = "c-button t-button-plain qa-edit-shipping-info"
              >
                {{ $t('web.settings.edit_button') }}
              </button>
            </div>
          </div>


          <!--EDIT-->
          <div
            v-if  = "layout.section9.template=='edit'"
            class = "c-card--setting__edit-fields"
          >
            <fieldset class="c-card--setting__fieldset c-card--setting__fieldset--address">
              <p class="c-card--setting__fieldset__note">
                {{ $t('web.settings.shipping_address_hint') }}
              </p>

              <label for="shipping_first_name" class="u-sub-label">
                {{ $t('web.settings.shipping_first_name_label') }}{{ metadata.shipping_first_name.required ? '*' : '' }}
              </label>
              <input
                v-model  = "participant.shipping_first_name"
                type     = "text"
                name     = "shipping_first_name"
                tabindex = "1"
                class    = "qa-settings-shipping-name-input"
              >
              <div v-for="error in errors.shipping_first_name">
                <div class="c-validation t-alert-danger qa-validation">
                  {{ error }}
                </div>
              </div>

              <label for="shipping_last_name" class="u-sub-label">
                {{ $t('web.settings.shipping_last_name_label') }}{{ metadata.shipping_last_name.required ? '*' : '' }}
              </label>
              <input
                v-model  = "participant.shipping_last_name"
                type     = "text"
                name     = "shipping_last_name"
                tabindex = "1"
                class    = "qa-settings-shipping-name-input"
              >
              <div v-for="error in errors.shipping_last_name">
                <div class="c-validation t-alert-danger qa-validation">
                  {{ error }}
                </div>
              </div>

              <label class="u-sub-label" for="shipping_address1">
                {{ $t('web.settings.shipping_address1_label') }}{{ metadata.shipping_address1.required ? '*' : '' }}
              </label>
              <input
                v-model  = "participant.shipping_address1"
                type     = "text"
                name     = "shipping_address1"
                tabindex = "2"
                class    = "qa-settings-shipping-street-line-1-input"
              />
              <div v-for="error in errors.shipping_address1">
                <div class="c-validation t-alert-danger qa-validation">
                  {{ error }}
                </div>
              </div>

              <label class="u-sub-label" for="shipping_address2">
                {{ $t('web.settings.shipping_address2_label') }}{{ metadata.shipping_address2.required ? '*' : '' }}
              </label>
              <input
                v-model      = "participant.shipping_address2"
                type         = "text"
                name         = "shipping_address2"
                :placeholder = "$t('web.settings.shipping_address2_placeholder')"
                tabindex     = "3"
                class        = "qa-settings-shipping-street-line-2-input"
              />
              <div v-for="error in errors.shipping_address2">
                <div class="c-validation t-alert-danger qa-validation">
                  {{ error }}
                </div>
              </div>

              <div class="c-card--setting__fieldset--address__city-state-zip">
                <label class="u-sub-label" for="shipping_city">
                  {{ $t('web.settings.shipping_city_label') }}{{ metadata.shipping_city.required ? '*' : '' }}
                </label>
                <input
                  v-model  = "participant.shipping_city"
                  type     = "text"
                  name     = "shipping_city"
                  tabindex = "4"
                  class    = "qa-settings-shipping-city-input"
                />
                <div v-for="error in errors.shipping_city">
                  <div class="c-validation t-alert-danger qa-validation">
                    {{ error }}
                  </div>
                </div>

                <label class="u-sub-label" for="shipping_state">
                  {{ $t('web.settings.shipping_state_label') }}{{ metadata.shipping_state.required ? '*' : '' }}
                </label>
                <select
                  v-model  = "participant.shipping_state"
                  name     = "shipping_state"
                  tabindex = "5"
                  class    = "qa-settings-shipping-state-input"
                >
                  <option value=""></option>
                  <option v-for="item in metadata.shipping_state.options":value="item.value">
                    {{ item.label }}
                  </option>
                </select>
                <div v-for="error in errors.shipping_state">
                  <div class="c-validation t-alert-danger qa-validation">
                    {{ error }}
                  </div>
                </div>

                <label class="u-sub-label" for="shipping_zip_code">
                  {{ $t('web.settings.shipping_zip_code_label') }}{{ metadata.shipping_zip_code.required ? '*' : '' }}
                </label>
                <input
                  v-model   = "participant.shipping_zip_code"
                  type      = "text"
                  maxlength = "6"
                  name      = "shipping_zip_code"
                  tabindex  = "6"
                  class     = "qa-settings-shipping-zip-input"
                />
                <div v-for="error in errors.shipping_zip_code">
                  <div class="c-validation t-alert-danger qa-validation">
                    {{ error }}
                  </div>
                </div>

                <label for="shipping_country" class="u-sub-label">
                  {{ $t('web.settings.shipping_country_label') }}{{ metadata.shipping_country.required ? '*' : '' }}
                </label>
                <select
                  v-model  = "participant.shipping_country"
                  name     = "shipping_country"
                  tabindex = "7"
                  class    = "qa-settings-country-input"
                >
                  <option value=""></option>
                  <option
                    v-for  = "item in metadata.shipping_country.options"
                    :value = "item.value"
                  >
                    {{ item.label }}
                  </option>
                </select>
                <div v-for="error in errors.shipping_country">
                  <div class="c-validation t-alert-danger qa-validation">
                    {{ error }}
                  </div>
                </div>

              </div>

              <label class="u-sub-label" for="shipping_email">
                {{ $t('web.settings.shipping_email_label') }}{{ metadata.shipping_email.required ? '*' : '' }}
              </label>
              <input
                v-model  = "participant.shipping_email"
                type     = "text"
                name     = "shipping_email"
                tabindex = "8"
                class    = "qa-settings-shipping-email-input"
              />
              <div v-for="error in errors.shipping_email">
                <div class="c-validation t-alert-danger qa-validation">
                  {{ error }}
                </div>
              </div>

              <label class="u-sub-label" for="shipping_phone">
                {{ $t('web.settings.shipping_phone_label') }}{{ metadata.shipping_phone.required ? '*' : '' }}
              </label>
              <input
                v-model  = "participant.shipping_phone"
                type     = "text"
                name     = "shipping_phone"
                tabindex = "9"
                class    = "qa-settings-shipping-phone-input"
              />
              <div v-for="error in errors.shipping_phone">
                <div class="c-validation t-alert-danger qa-validation">
                  {{ error }}
                </div>
              </div>
            </fieldset>

            <div class="c-card--setting__buttons c-card--setting__buttons--edit-mode">
              <button
                @click   = "reset()"
                class    = "c-button t-button-plain"
                tabindex = "11"
              >
                {{ $t('web.settings.cancel_button') }}
              </button>
              <button
                @click   = "save('section9')"
                class    = "c-button t-button-primary qa-save"
                tabindex = "10"
              >
                {{ $t('web.settings.save_button') }}
              </button>
            </div>
          </div>
        </section>
      </section>
    </main>




    <app-footer></app-footer>
  </div>
</template>




<script>
import Vue from 'vue'
import _ from 'lodash'
import $ from 'jquery'
import API from '@/services'
import util from '@/functions'
import validate from 'validate.js'
import { mapActions, mapGetters } from 'vuex'
import FieldCurrency from '@/views/components/fields/FieldCurrency'
import FieldVarchar from '@/views/components/fields/FieldVarchar'
import FieldEmail from '@/views/components/fields/FieldEmail'
import FieldDate from '@/views/components/fields/FieldDate'
import FieldDecimal from '@/views/components/fields/FieldDecimal'
import FieldPercent from '@/views/components/fields/FieldPercent'
import FieldInteger from '@/views/components/fields/FieldInteger'
import FieldBool from '@/views/components/fields/FieldBool'
import FieldEnum from '@/views/components/fields/FieldEnum'
import FieldFileUpload from '@/views/components/fields/FieldFileUpload'
export default {
  name: 'settings',
  data () {
    return {
      metadata: this.$store.state.websiteConfig.metadata.Participant,
      participant: JSON.parse(JSON.stringify(this.$store.state.participant)),
      errors: {},
      customProfile: {
        name: '',
        fields: []
      },
      layout: {
        section1: {
          template: 'detail',
          fields: [ 'primary_email' ]
        },
        password_section: {
          template: 'detail',
          fields: [ 'old_password', 'new_password', 'confirm_new_password' ]
        },
        section3: {
          template: 'detail',
          fields: [ 'first_name', 'last_name' ]
        },
        section4: {
          template: 'detail',
          fields: [ 'preferred_first_name', 'preferred_last_name' ]
        },
        section6: {
          template: 'detail',
          fields: [ 'secondary_email', 'other_email' ]
        },
        section7: {
          template: 'detail',
          fields: [ 'mobile_phone', 'business_phone', 'home_phone' ]
        },
        section8: {
          template: 'detail',
          fields: [
            'home_address1',
            'home_address2',
            'home_city',
            'home_state',
            'home_zip_code',
            'home_country'
          ]
        },
        section9: {
          template: 'detail',
          fields: [
            'shipping_first_name',
            'shipping_last_name',
            'shipping_address1',
            'shipping_address2',
            'shipping_city',
            'shipping_state',
            'shipping_zip_code',
            'shipping_country',
            'shipping_email',
            'shipping_phone'
          ]
        }
      }
    }
  },
  components: {
    fieldCurrency: FieldCurrency,
    fieldVarchar: FieldVarchar,
    fieldEmail: FieldEmail,
    fieldDate: FieldDate,
    fieldDecimal: FieldDecimal,
    fieldInteger: FieldInteger,
    fieldPercent: FieldPercent,
    fieldBool: FieldBool,
    fieldEnum: FieldEnum,
    fieldFileUpload: FieldFileUpload
  },
  computed: {
    ...mapGetters({
      websiteConfig: 'websiteConfig'
    }),
    full_name () {
      if (!this.participant.first_name && !this.participant.last_name) {
        return this.$t('web.settings.name_not_entered')
      } else {
        return [this.participant.first_name, this.participant.last_name]
          .filter((el) => !!el)
          .join(' ')
      }
    },
    preferred_full_name () {
      if (!this.participant.preferred_first_name &&
          !this.participant.preferred_last_name) {
        return this.$t('web.settings.preferred_name_not_entered')
      } else {
        return [
          this.participant.preferred_first_name,
          this.participant.preferred_last_name
        ]
          .filter((el) => !!el)
          .join(' ')
      }
    },
    home_address_empty () {
      if (!this.participant.home_address1 &&
          !this.participant.home_address2 &&
          !this.participant.home_city &&
        !this.participant.home_state &&
        !this.participant.home_zip_code &&
        !this.participant.home_country) {
        return true
      } else {
        return false
      }
    },
    shipping_address_empty () {
      if (!this.participant.shipping_address1 &&
          !this.participant.shipping_address2 &&
          !this.participant.shipping_city &&
          !this.participant.shipping_state &&
          !this.participant.shipping_zip_code &&
          !this.participant.shipping_first_name &&
          !this.participant.shipping_last_name &&
          !this.participant.shipping_country) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    this.LOAD_PARTICIPANT(this.$router)
      .then(() => {
        this.reset()
      })
    this.customProfile = _.cloneDeep(this.websiteConfig.profile)
    _.each(this.customProfile.fields, (item) => {
      this.$set(this.layout, 'custom_section_' + item.name, {
        template: 'detail',
        fields: [item.name],
        custom: true
      })
    })
  },
  methods: {
    ...mapActions([
      'LOAD_PARTICIPANT',
      'LOGOUT'
    ]),
    getDropdownLabel (value, options) {
      return util.getDropdownLabel(value, options)
    },
    getFieldComponentType (field) {
      return 'field-' + _.replace(field.type, '_', '-')
    },
    edit: function (section) {
      this.reset()
      this.layout[section].template = 'edit'
      Vue.nextTick(function () {
        if (section === 'password_section') {
          util.showPassword()
        }
      })
    },
    reset: function () {
      for (var i in this.layout) {
        this.layout[i].template = 'detail'
      }
      this.participant = JSON.parse(JSON.stringify(this.$store.state.participant))
      this.errors = {}
      // create a reactive array of error messages for each field
      _.each(this.customProfile.fields, (item) => {
        this.$set(this.errors, item.name, null)
      })
    },
    save: function (section) {
      var valid
      valid = this._validateFields(section)
      if (valid) {
        var fields = {}
        for (var i in this.layout[section].fields) {
          fields[this.layout[section].fields[i]] = this.participant[this.layout[section].fields[i]]
        }
        console.log(fields)
        let formData = new FormData()
        formData.append('field_values', JSON.stringify(fields))
        console.log(formData)
        _.each(this.layout[section].fields, (field, i) => {
          // if it's an actual field (and not 'old_password'), check if the files should be uploaded as well
          if (this.metadata[field] && this.metadata[field].type === 'file_upload') {
            // get the files for upload
            console.log(this.metadata[field].type)
            let files = _.find(this.$children, (item) => {
              return item.field && item.field.name === field
            }).$refs.dropzone.getAddedFiles()
            _.each(files, (file) => {
              formData.append(field + '[]', file)
            })
          }
        })
        console.log(formData)
        API.postAuthenticated('participants/profile', formData)
        .then((response) => {
          // if locale field was updated
          if (section === 'custom_section_locale' &&
            response.data.participant.locale !== this.$store.state.participant.locale) {
            window.location.reload()
          } else {
            this.$store.commit('UPDATE_PARTICIPANT', response.data.participant)
            this.reset()
          }
        })
        .catch((error) => {
          // server-side validation
          if (error.response && error.response.status === 400) {
            this.errors = error.response.data.errors
          }
        })
      }
    },
    _validateFields: function (section) {
      var constraints = {
        first_name: { presence: { message: this.$t('web.settings.first_name_required') } },
        last_name: { presence: { message: this.$t('web.settings.last_name_required') } },
        primary_email: {
          presence: { message: this.$t('web.settings.primary_email_required') },
          email: { message: this.$t('web.settings.primary_email_invalid') }
        },
        secondary_email: {
          email_or_empty: { message: this.$t('web.settings.secondary_email_invalid') }
        },
        other_email: {
          email_or_empty: { message: this.$t('web.settings.other_email_invalid') }
        },
        old_password: { presence: { message: this.$t('web.settings.old_password_required') } },
        new_password: {
          presence: { message: this.$t('web.settings.new_password_required') },
          length: {
            minimum: 12,
            tooShort: this.$t('web.settings.new_password_minimum_12_characters')
          },
          customPassword: true
        },
        confirm_new_password: {
          presence: { message: this.$t('web.settings.confirm_new_password_required') },
          equality: { attribute: 'new_password', message: this.$t('web.settings.confirm_new_password_dont_match') }
        }
      }
      var validation = {}
      for (var i in this.layout[section].fields) {
        if (typeof constraints[this.layout[section].fields[i]] !== 'undefined') {
          validation[this.layout[section].fields[i]] = constraints[this.layout[section].fields[i]]
        }
      }
      validate.validators.email_or_empty = function (value, options, key, attributes) {
        var message = options.message
        // Empty values are fine
        if (validate.isEmpty(value)) {
          return
        }
        if (!validate.validators.email.PATTERN.exec(value)) {
          return message
        }
      }
      let _self = this
      validate.validators.customPassword = function (value, options, key, attributes) {
        var errors = []
        if (typeof value !== 'undefined') {
          var expUpper = /.*[A-Z]+.*/g
          var expNumber = /.*\d+.*/g
          var expSpace = /.*\s+.*/g
          var expSpecial = /.*[\W_]+.*/g
          var regUpper = new RegExp(expUpper)
          var regNumber = new RegExp(expNumber)
          var regSpace = new RegExp(expSpace)
          var regSpecial = new RegExp(expSpecial)
          if (!value.match(regUpper)) {
            errors.push(_self.$t('web.settings.new_password_minimum_1_uppercase'))
          }
          if (!value.match(regNumber)) {
            errors.push(_self.$t('web.settings.new_password_minimum_1_number'))
          }
          if (value.match(regSpace)) {
            errors.push(_self.$t('web.settings.new_password_no_spaces'))
          }
          if (!value.match(regSpecial)) {
            errors.push(_self.$t('web.settings.new_password_minimum_1_symbol'))
          }
        }
        return errors
      }
      var errors = validate(this.participant, validation, {fullMessages: false})
      if ('custom' in this.layout[section] && this.layout[section].custom) {
        var fieldDef = null
        _.each(this.customProfile.fields, (field) => {
          if (this.layout[section].fields[0] === field.name) {
            fieldDef = field
          }
        })
        var error = util.validateField(
          fieldDef,
          this.participant[this.layout[section].fields[0]],
          $(this.$el).find('[name="' + this.layout[section].fields[0] + '"] input')[0]
        )
        if (typeof error !== 'undefined' && error !== '') {
          if (typeof errors === 'undefined') {
            errors = {}
          }
          errors[this.layout[section].fields[0]] = [error]
        }
      }
      if (typeof errors === 'undefined') {
        this.errors = {}
        return true
      } else {
        this.errors = errors
        return false
      }
    },
    logout (e) {
      e.preventDefault()
      this.LOGOUT(this.$router)
    }
  }
}
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// Settings.vue?7b7305fe